import { render, staticRenderFns } from "./AttachmentListDialog.vue?vue&type=template&id=ee2c274e&scoped=true"
import script from "./AttachmentListDialog.vue?vue&type=script&lang=js"
export * from "./AttachmentListDialog.vue?vue&type=script&lang=js"
import style0 from "./AttachmentListDialog.vue?vue&type=style&index=0&id=ee2c274e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2c274e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee2c274e')) {
      api.createRecord('ee2c274e', component.options)
    } else {
      api.reload('ee2c274e', component.options)
    }
    module.hot.accept("./AttachmentListDialog.vue?vue&type=template&id=ee2c274e&scoped=true", function () {
      api.rerender('ee2c274e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/components/AttachmentListDialog.vue"
export default component.exports